import ErrorItems from "components/Editorial/ActionsMenu/ErrorItems";
import MenuItemType from "components/Editorial/ActionsMenu/PropTypes/MenuItemType";
import MenuList from "components/Editorial/ActionsMenu/MenuList";
import MobileToggle from "components/Editorial/ActionsMenu/MobileToggle";
import PropTypes from "prop-types";
import React, { useState } from "react";
import ReactMenuItemType from "components/Editorial/ActionsMenu/PropTypes/ReactMenuItemType";
import classNames from "classnames";

export default function ActionsMenu({ error, loading, menuItems }) {
  if (loading) { return <React.Fragment />; }

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const items = error ? ErrorItems.render() : menuItems;

  return (
    <nav className={classNames("editorial-menu", { opened: mobileMenuOpen })}>
      <MobileToggle onClick={() => setMobileMenuOpen(!mobileMenuOpen)} />

      <div className="wrapper">
        <MenuList items={items} />
      </div>
    </nav>
  );
}

ActionsMenu.propTypes = {
  error: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.oneOfType([MenuItemType, ReactMenuItemType]),
  ).isRequired,
};
